import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import {Paper,Grid,Switch} from '@material-ui/core'

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise'

import callAccountsApi from '../data-provider'

import ActionCellRenderer from '../components/action-cell-renderer'
import getGridConfig from './grid-config-cars'
import Menu from './menu'
import CarForm from './car-form'

const styles = theme => ({
  paper: {
    overflowX: 'auto',
    backgroundColor : '#fff',
    padding : 10,
    margin : 'auto',
    position : 'fixed',
    top : 300,
    bottom : 20,
    left : 20,
    right : 20,
  },
})

class ManageCars extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {cars:[],car:null,showInactive:false,users:[]}
  }

  componentDidMount() {
    this.getCars()
    this.getUsers()
  }

  getCars = async () => {
    let cars = await callAccountsApi("manage","getCars")
    this.setState({cars})
  }

  getUsers = async () => {
    let users = await callAccountsApi("users","getUsers")
    this.setState({users})
  }

  actionClickHandler = (action,car) => {
    switch(action)
    {
      case "new" : return this.openForm({})
      case "view" : return this.openForm(car)
      case "edit" : return this.openForm(car)
      default: {}
    }
  }

  onRowDoubleClicked = row => {
    this.openForm(row.data)
  }
  
  openForm = car => {
    this.setState({car})
  }

  closeForm = refresh => {
    this.setState({car:null})
    if (refresh)
    {
      this.getCars()
    }
  }

  toggleInactive = () => {
    let showInactive = !this.state.showInactive
    this.setState({showInactive})
  }

  render() {
    const { classes } = this.props

    let columnDefs = getGridConfig(this.actionClickHandler)
    let cars = this.state.cars.filter(c => c.active || this.state.showInactive)

    return (
      <React.Fragment>
          
        <Menu page="cars"/>

        <span style={{float:"right",color:'#fff'}}>
          <Grid component="label" container item alignItems="center" spacing={1}>
            <Grid item>Active Cars</Grid>
            <Grid item>
              <Switch
                checked={this.state.showInactive}
                onChange={this.toggleInactive}
                color="primary"
              />
            </Grid>
            <Grid item>All Cars</Grid>
          </Grid>
        </span>

        <Paper className={classes.paper}>
          <div className="ag-theme-alpine" style={ {width: '100%' }}>
            <AgGridReact rowData={cars} columnDefs={columnDefs} domLayout='autoHeight' frameworkComponents={{actionCellRenderer : ActionCellRenderer}} onRowDoubleClicked={this.onRowDoubleClicked}/>
          </div>
        </Paper>

        <CarForm open={this.state.car !== null} close={this.closeForm} car={this.state.car} users={this.state.users}/>

      </React.Fragment>
    )
  }
}

export default withRouter(withStyles(styles)(ManageCars))
